import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const KEY = "om_cookie_consent";
const TWELVE_MONTHS = 365 * 24 * 60 * 60 * 1000;

const CookieConsent = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        try {
            const raw = localStorage.getItem(KEY);
            if (!raw) {
                setShow(true);
                return;
            }
            const { ts } = JSON.parse(raw);
            if (Date.now() - ts > TWELVE_MONTHS) setShow(true);
        } catch {
            setShow(true);
        }
    }, []);

    const choose = (choice) => {
        localStorage.setItem(KEY, JSON.stringify({ choice, ts: Date.now() }));
        setShow(false);
    };

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ y: 80, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 80, opacity: 0 }}
                    className="fixed bottom-0 inset-x-0 z-[85] bg-[#0a1e3f] border-t border-gold/30 shadow-2xl"
                    data-testid="cookie-consent-banner"
                    role="dialog"
                    aria-label="Cookie consent"
                >
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row items-center gap-2.5 sm:gap-4">
                        <p className="text-white text-xs sm:text-sm font-normal flex-1 text-center sm:text-left leading-relaxed" style={{ fontFamily: "Outfit, sans-serif" }}>
                            We use cookies to improve your experience. By continuing, you agree to our{" "}
                            <Link to="/privacy-policy/" className="text-gold underline underline-offset-2 hover:text-gold-bright" data-testid="cookie-privacy-link">
                                Privacy Policy
                            </Link>
                            .
                        </p>
                        <div className="grid grid-cols-2 gap-2 w-full sm:w-auto sm:flex">
                            <button
                                onClick={() => choose("accepted")}
                                data-testid="cookie-accept-button"
                                className="bg-gold text-navy font-bold text-xs sm:text-sm px-4 sm:px-6 py-2.5 rounded-sm hover:bg-gold-bright transition-colors"
                            >
                                Accept All
                            </button>
                            <button
                                onClick={() => choose("declined")}
                                data-testid="cookie-decline-button"
                                className="border border-white/40 text-white font-semibold text-xs sm:text-sm px-4 sm:px-6 py-2.5 rounded-sm hover:bg-white/10 transition-colors"
                            >
                                Decline
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieConsent;
